import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getBlogById, updateLikes } from "./singleBlogApi";

const initialState = {
    isLoading: false,
    isError: false,
    blog: {},
    error: ""
}

export const fetchBlog = createAsyncThunk("blog/fetchBlog", async(id) => {
    const blog = getBlogById(id);
    return blog;
})

export const updateBlog = createAsyncThunk("blog/addLike", async(updatedData) => {
    const blog = updateLikes(updatedData)
    return blog;
})

const singleBlogSlice = createSlice({
    name: "blog",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchBlog.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
            state.error = "";
        })
        builder.addCase(fetchBlog.fulfilled, (state, action) => {
            state.isLoading = false;
            state.blog = action.payload
        })
        builder.addCase(fetchBlog.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.blog = {}
            state.error = action.error.message
        })
       /*  builder.addCase(addLike.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
            state.error = ""
        }) */
        builder.addCase(updateBlog.fulfilled, (state, action) => {
            state.isLoading = false;
            const {likes, isSaved} = action.payload
            state.blog = {...state.blog, likes, isSaved }
        })
        builder.addCase(updateBlog.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.blog = {}
            state.error = action.error.message
        })
    }
})

export default singleBlogSlice.reducer;